require("./main.scss");

(function ($) {

    $(document).ready(function () {

        // let menu = $(".menu-main-container");
        // let header = $(".main-header");
        // let nav = $(".toggle-nav");

        // let pHeight = $('.menu')[0].scrollHeight+$('.menu').outerHeight();

        // // console.log(pHeight);

        // menu.css('max-height', '0px');

        // nav.click(function (e) {

        //     e.preventDefault();

        //     $(this).toggleClass("open-nav");
        //     header.toggleClass("open-header");

        //     if (header.hasClass("open-header")) {
        //         menu.css('max-height', pHeight+'px');
        //     } else {
        //         menu.css('max-height', '0px');
        //     }


        // });

        // $(".menu-item.scroll > a").click(function(e){
        //     nav.removeClass("open-nav");
        //     header.removeClass("open-header");
        //     if (header.hasClass("open-header")) {
        //         menu.css('max-height', pHeight+'px');
        //     } else {
        //         menu.css('max-height', '0px');
        //     }
        // })

        // $("section#tattoo-policy .container").after().click(function (e) {
        //     $("section#tattoo-policy").fadeOut(300);
        // });

        // $(".wp-block-button.is-style-modal").click(function (e) {
        //     $("section#tattoo-policy").css('display', 'flex').hide().fadeIn(300);
        // });

        $("form#form-book-now .paragraph-custom-view__ a").click(function (e) {
            $("section#tattoo-policy").css('display', 'flex').hide().fadeIn(300);
        });


    });

})(jQuery)

